// src/blogs/ActivePostContext.js
// Which post is currently "mainly being viewed" (BlogShell tracks it via
// InfiniteBlogFeed), shared with the posts themselves so one can react to
// being the active one.
import { createContext, useContext } from "react";

export const ActivePostContext = createContext(null);

/**
 * Extra class names for a post's <article>, for posts whose theme has
 * `hideText: true` — i.e. whose 3D backdrop scene prints the post's text
 * itself (see postScenes/HoloClothScene.jsx). While such a post is the active
 * one its DOM text fades out, leaving the scene's copy; it stays in the
 * document (and for screen readers) and keeps its layout height.
 * Returns "" for every other post.
 */
export function useScenePostClass(post) {
  const activeId = useContext(ActivePostContext);
  if (!post.theme?.hideText) return "";
  return activeId === post.id ? "post--scene-text-host post--scene-text" : "post--scene-text-host";
}
